import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated } from "utils/common";
import { ChevronRight } from "assets/svg";
import { postContact } from "features/Contact/contactSlice";
import { useHistory } from "react-router";
import { SERVICE } from "constants/global";
import { getUser } from "features/User/userSlice";
import ErrorDB from "components/ErrorDB";

function ConfirmContact() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { info, isInLine } = useSelector((state) => state.contact);
  const { user, userDisplay } = useSelector((state) => state.user);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (!info) {
      history.push(PATH.CONTACT);
    }

    if (isAuthenticated()) {
      dispatch(getUser());
    }
  }, []);

  const checkIsAuth = () => {
    if (
      (info.type == 1 && isAuthenticated()) ||
      (info.type == 0 && !isAuthenticated())
    ) {
      return true;
    }
    return false;
  };

  const backSubmit = () => {
    if (checkIsAuth()) {
      history.push(PATH.CONTACT);
    } else {
      window.location.reload();
    }
  };

  const onSubmit = () => {
    if (checkIsAuth()) {
      dispatch(postContact({ data: { service: SERVICE, ...info }, history }));
    } else {
      window.location.reload();
    }
  };

  return (
    <div
      className={
        isAuthenticated() ? "w-80 py-0 py-md-3" : "container px-3 px-lg-0 p-15"
      }
    >
      <div className="py-3 text-center">
        <div className="fs-20 fs-sm-18 fw-600 sp-14">お問い合わせ</div>
        <div className="sp-14 fw-600 my-2">入力内容をご確認ください。</div>
      </div>

      {isAuthenticated() ? (
        <div className="px-3 px-lg-0 p-15">
          <div className="fs-14 fw-600">{userDisplay?.name}さん</div>
          <div className="border-color-grey text-grey fw-600 fs-12 px-3 py-2 my-2">
            <div className="mb-1">ご登録のメールアドレス：{user?.login}</div>
            <div>ご登録の電話番号：{user?.phone}</div>
          </div>
          <table className="table-view min-height-190 my-3 w-100">
            <tbody>
              <tr className="min-height-190">
                <td className="fs-14 fw-600 ps-3">お問い合わせ内容</td>
                <td className="ps-2 ps-md-3">{info?.body}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <table className="table-view w-100">
          <tbody>
            <tr>
              <td className="fs-14 fw-600 ps-3">お名前</td>
              <td className="ps-2 ps-md-3">
                {info?.last_name + " " + info?.first_name}
              </td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">お名前 (カナ)</td>
              <td className="ps-2 ps-md-3">
                {info?.last_name_kana + " " + info?.first_name_kana}
              </td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">メールアドレス</td>
              <td className="ps-2 ps-md-3">{info?.email}</td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">電話番号</td>
              <td className="ps-2 ps-md-3">{info?.phone}</td>
            </tr>
            <tr className="min-height-190">
              <td className="fs-14 fw-600 ps-3">お問い合わせ内容</td>
              <td className="ps-2 ps-md-3 min-height-190">{info?.body}</td>
            </tr>
          </tbody>
        </table>
      )}
      {isInLine && <ErrorDB style={'mt-4'}/>}

      <div className="d-flex flex-column">
        <div className="order-2 order-md-1 group-btn-custom mt-5">
          <div onClick={backSubmit} className="btn-custom after">
            内容を修正する
          </div>
          <div
            onClick={() => onSubmit()}
            className="btn-custom red-light before"
          >
            入力内容を送信
          </div>
        </div>

        {isAuthenticated() && (
          <div className="order-1 order-md-2 text-center text-grey fw-700 my-3">
            <div className="mt-2">
              <a href={PATH.CHANGE_EMAIL}>
                ご登録のメールアドレスを変更する
                <span className="ms-2">
                  <ChevronRight />
                </span>
              </a>
            </div>
            <div className="mt-2">
              <a href={PATH.MEMBER_INFO}>
                ご登録の電話番号を変更する
                <span className="ms-2">
                  <ChevronRight />
                </span>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConfirmContact;
